<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <a class="nav-link mr20 navbar-head-dropdown"><!--icon icon="user-md"></icon--><img src="../../../../assets/img/doctor-avatar.svg"><p>{{globals.username}}</p><icon icon="caret-down"></icon></a>
        </template>
        <b-dropdown-item><a target="_blank" href="/"><icon icon="globe"></icon> {{$t('OPENSITEINNEWWINDOW')}}</a></b-dropdown-item>
        <b-dropdown-item v-on:click.prevent="showModal()"><a href=""><icon icon="key"></icon> {{$t('CHANGEPASSWORD')}}</a></b-dropdown-item>
        <b-dropdown-item v-on:click.prevent="logout"><a href=""><icon icon="sign-out-alt"></icon> {{$t('LOGOUT')}}</a></b-dropdown-item>
        <b-modal ref="formmodal" :title="$t('CHANGEPASSWORD')" ok-title="submit" hide-footer no-close-on-backdrop @close="hideModal()">
          <div class="d-block">
            <passwordform v-bind:formData="formData" v-bind:formError="formError"></passwordform>
          </div>
          <div class="text-right">
            <b-btn class="mr-2 button-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
            <b-btn class="button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
          </div>
        </b-modal>
      </b-nav-item-dropdown>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Api from '@/api/admin/Users';
import PasswordForm from './PasswordForm.vue';

export default
{
    name: 'header-dropdown-accnt',
    components:
  {
      passwordform: PasswordForm,
  },
    data()
    {
        return {
            formError:
      {},
            formData:
      {
          oldPassword: '',
          password: '',
          password2: '',
      },
        };
    },
    methods:
  {
      ...mapActions([
          'logout',
      ]),
      showModal()
      {
          const me = this;
          me.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              const data = await Api.changePassword(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();

          me.formData = {
              oldPassword: '',
              password: '',
              password2: '',
          };
      },
  },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
  },
};
</script>
